/**
 * Utility functions for unit conversions
 */

/**
 * Converts a glucose value between mg/dL and mmol/L
 * @param {number} value - The glucose value to convert
 * @param {string} targetUnit - The target unit ('mg/dL' or 'mmol/L')
 * @returns {number} The converted value
 */
export function convertGlucoseValue(value, targetUnit) {
  if (value === null || value === undefined || isNaN(value)) return null;
  
  if (targetUnit === 'mmol/L') {
    //return Number((value / 18).toFixed(1));
    return Number((value * 0.0555).toFixed(1)); // NIH formula
  }
  return Number((value).toFixed(0));
}

/**
 * Formats a glucose value with its unit
 * @param {number} value - The glucose value in mg/dL
 * @param {string} displayUnit - The unit to display ('mg/dL' or 'mmol/L')
 * @returns {string} The formatted value with unit
 */
export function formatGlucoseValue(value, displayUnit) {
  if (value === null || value === undefined || isNaN(value)) return 'N/A';
  
  const convertedValue = convertGlucoseValue(value, displayUnit);
  return `${convertedValue} ${displayUnit}`;
} 